import './App.css';
import { StoreProvider, useStore } from './context/StoreContext';
import { Header } from './widgets/Header';
import { Footer } from './widgets/Footer';
import { MobileTabbar } from './widgets/MobileTabbar';
import { AuthModal } from './widgets/AuthModal';
import { Notice } from './shared/ui/Notice';
import { HomePage } from './pages/HomePage';
import { CatalogPage } from './pages/CatalogPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { AccountPage } from './pages/AccountPage';
import { OrderCompletePage } from './pages/OrderCompletePage';
import { AdminPage } from './pages/AdminPage';

function AppContent() {
  const { page, notice, noticeVersion, setNotice, go, authOpen, selectedProduct } = useStore();

  if (page === 'admin') {
    return (
      <div className="storefront admin-mode">
        {notice && <Notice key={noticeVersion} message={notice} onDismiss={() => setNotice('')} onViewBag={() => go('cart')} />}
        <AdminPage />
        {authOpen && <AuthModal />}
      </div>
    );
  }

  return (
    <div className="storefront">
      <Header />
      <main>
        {notice && <Notice key={noticeVersion} message={notice} onDismiss={() => setNotice('')} onViewBag={() => go('cart')} />}
        {page === 'home' && <HomePage />}
        {page === 'catalog' && <CatalogPage />}
        {page === 'product' && selectedProduct && <ProductDetailPage />}
        {page === 'cart' && <CartPage />}
        {page === 'checkout' && <CheckoutPage />}
        {page === 'account' && <AccountPage />}
        {page === 'complete' && <OrderCompletePage />}
      </main>
      <Footer />
      <MobileTabbar />
      {authOpen && <AuthModal />}
    </div>
  );
}

function App() {
  return (
    <StoreProvider>
      <AppContent />
    </StoreProvider>
  );
}

export default App;
